import { ControlFacet } from '../models/controls/ControlFacet';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';

/**
 * @public
 */
export interface IOnItemUploadedPayload {
    progressItemKey: string;
}

/**
 * @public
 */
export interface IUploadItemsActionControlProps {
    itemKey: string | undefined;
}

/**
 * @public
 */
export interface IUploadItemsActionControlOverrides {
    /**
     * Hook to override whether the given item supports uploading child items.
     */
    isAvailable: boolean;
    /**
     * Hook which is invoked when any item is uploaded.
     */
    onItemUploaded: (payload: IOnItemUploadedPayload) => IItemCacheThunkAction<void>;
}

export const uploadItemsActionControl: ControlFacet<IUploadItemsActionControlProps, IUploadItemsActionControlOverrides> =
    new ControlFacet('uploadItemsActionControl');